import CompareInfo from './CompareInfo';
import CreatePointInfo from './CreatePointInfo';
import DncFlexibleInfo from './DncFlexibleInfo';
import GreenfieldInfo from './GreenfieldInfo';
import NewGreenfieldInfo from './NewGreenfieldInfo';
import BrownfieldInfo from './BrownfieldInfo';
import MarkedAreaInfo from './MarkedAreaInfo';
import PointOfInterestInfo from './PointOfInterestInfo';
import ResumeInfo from './ResumeInfo';
import SelectedAreasInfo from './SelectedAreasInfo';
import StoresInfo from './StoresInfo';
import SummaryInfo from './SummaryInfo';
import VoronoiInfo from './VoronoiInfo';
import DistanceReportInfo from './DistanceReportInfo';
import SelectedAreasAfterSalesInfo from './AfterSales/SelectedAreasAfterSalesInfo';
import StoresInfoAfterSalesInfo from './AfterSales/StoresInfoAfterSales';
import ResumeAfterSalesInfo from './AfterSales/ResumeAfterSalesInfo';
import SummaryAfterSalesInfo from './AfterSales/SummaryAfterSalesInfo';
import MulticriteriaAfterSalesInfo from './AfterSales/MulticriteriaAfterSalesInfo';
import MarkedAreaAfterSalesInfo from './AfterSales/MarkedAreaAfterSalesInfo';
import DealershipAfterSalesInfo from './AfterSales/DealershipAfterSalesInfo';

const views = {
    CompareInfo,
    CreatePointInfo,
    DncFlexibleInfo,
    GreenfieldInfo,
    NewGreenfieldInfo,
    BrownfieldInfo,
    MarkedAreaInfo,
    PointOfInterestInfo,
    DistanceReportInfo,
    ResumeInfo,
    SelectedAreasInfo,
    StoresInfo,
    SummaryInfo,
    VoronoiInfo,

    // After Sales
    MarkedAreaAfterSalesInfo,
    SelectedAreasAfterSalesInfo,
    StoresInfoAfterSalesInfo,
    DealershipAfterSalesInfo,
    ResumeAfterSalesInfo,
    SummaryAfterSalesInfo,
    MulticriteriaAfterSalesInfo
};

export const get = (name) => {
    const view = views[`${name}Info`];

    if (view) {
        return view.getInstance();
    }
};

export default views;



// WEBPACK FOOTER //
// ./src/scripts/info/index.js